module.exports = __webpack_public_path__ + "static/img/sedan-white.5930d67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sedan-white.svg
// module id = hw3n
// module chunks = 82